"use client"

import VimeoVideoElement from "@/app/(site)/_components/SanityElements/VimeoVideoElement"
import { getVideoPlaybackUrl } from "@/src/utils/video/get-video-playback-url"
import { type ImageType } from "@/types"

interface VideoElementProps {
    vimeoId?: string
    videoFileUrl?: string
    caption?: string
    autoplay: boolean
    mute: boolean
    hasSound: boolean
    loop?: boolean
    hideControls?: boolean
    poster?: ImageType | null
}

export default function VideoElement({
    caption,
    vimeoId = "",
    videoFileUrl = "",
    autoplay = true,
    mute = true,
    hasSound = false,
    loop = false,
    hideControls = false,
    poster
}: VideoElementProps) {
    const playbackUrl = getVideoPlaybackUrl(vimeoId, videoFileUrl)

    if (!playbackUrl) {
        return null
    }

    return (
        <VimeoVideoElement
            vimeoId={playbackUrl}
            caption={caption}
            autoplay={autoplay}
            mute={mute}
            hasSound={hasSound}
            hideControls={hideControls}
            loop={loop}
            poster={poster}
        />
    )
}
